import { AfterViewInit, Component, ElementRef, inject, ViewChild } from '@angular/core';
import { ModalController } from '@ionic/angular';
import * as confetti from 'canvas-confetti';

@Component({
  selector: 'app-account-transactions-referral-modal',
  standalone: false,
  templateUrl: './account-transactions-referral-modal.component.html',
  styleUrl: './account-transactions-referral-modal.component.scss'
})
export class AccountTransactionsReferralModalComponent implements AfterViewInit {
  private modalController = inject(ModalController);

  @ViewChild('confettiStarter') confettiEl!: ElementRef<HTMLImageElement>;

  ngAfterViewInit() {
    this.launchConfetti();
  }

  launchConfetti() {
    setTimeout(() => {
      const rect = this.confettiEl.nativeElement.getBoundingClientRect();

      const x = (rect.left + rect.width / 2) / window.innerWidth;
      const y = (rect.top + rect.height / 2) / window.innerHeight;

      confetti.default({
        particleCount: 150,
        spread: 75,
        origin: { x, y },
        gravity: 0.9,
        ticks: 200
      });
    }, 400);
  }

  onDismiss() {
    this.modalController.dismiss();
  }

  onInvited() {
    this.modalController.dismiss({ invite: true });
  }
}
